import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { AppUrlConstants } from '../../../core/constants/AppUrlConstants';
import { AlertDialogComponent } from '../../../shared/alert-dialog/alert-dialog.component';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { GenericCrudService } from '../../../core/services/generic-crud.service';

@Component({
  selector: 'app-add-edit-dialog',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatSelectModule, FormsModule, MatButtonModule,
    ReactiveFormsModule, MatDialogClose, TranslateModule],
  templateUrl: './groups-add-edit-dialog.component.html',
})
export class GroupsAddEditDialogComponent {
  form: FormGroup;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GroupsAddEditDialogComponent>,
    public dialog: MatDialog, private formBuilder: FormBuilder,
    private crudService: GenericCrudService) {
  }
  groupTypeOptions = ['Committee', 'Non-committee'];

  ngOnInit() {
    this.form = this.formBuilder.group({
      groupId: [null],
      name: ['', [Validators.required, Validators.maxLength(60)]],
      description: ['', [Validators.required, Validators.maxLength(300)]],
      groupType: ['', [Validators.required]]
    });
    if (this.data != null) {
      this.form.patchValue(this.data);
    }
  }
  add() {
    this.crudService.add(this.form.value, AppUrlConstants.GROUP_URL + AppUrlConstants.ADD).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  edit() {
    this.crudService.edit(this.form.value, AppUrlConstants.GROUP_URL + AppUrlConstants.EDIT).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
}
